import {Button} from "react-bootstrap";
import React, {FC, useContext, useState} from "react";
import {AuthContext} from "contexts";
import {blackListService} from "services/blackListService";
import {UpdateBlackListModal} from "pages/BlackList/components/UpdateBlackListModal";

interface Props {
    onSave: () => void
}

export const AddToBlackListModal: FC<Props> = ({onSave}) => {
    const {env} = useContext(AuthContext);

    const [isModalVisible, setIsModalVisible] = useState(false);


    const handleSave = async ({name, photos}: { name: string, photos: File[] }) => {
        if (!env) {
            return
        }
        await blackListService.add(env, {name, files: photos});
        onSave()
    }

    return <div className="d-flex flex-row justify-content-end w-100">
        <Button
            onClick={() => setIsModalVisible(true)}
            variant="outline-primary">
            Добавить в Черный Список
        </Button>

        <UpdateBlackListModal
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            handleSave={handleSave}
        />
    </div>
}